import api from "./API";

/**
 * Department Stock Service
 * API service for managing department-level inventory allocations
 */

export const departmentStockService = {
  /**
   * Get all department stocks with optional filters and pagination
   * @param {Object} params - Query parameters (page, limit, department, item, status, etc.)
   * @returns {Promise} API response with department stocks list
   */
  getDepartmentStocks: (params) => api.get("/department-stock", { params }),

  /**
   * Get department stocks for a specific department
   * @param {string} departmentId - Department ID
   * @param {Object} params - Query parameters (item, status, etc.)
   * @returns {Promise} API response with department's stock allocations
   */
  getDepartmentStockByDept: (departmentId, params = {}) => 
    api.get(`/department-stock/department/${departmentId}`, { params }),

  /**
   * Get department stocks for a specific item
   * @param {string} itemId - Item ID
   * @param {Object} params - Query parameters (department, status, etc.)
   * @returns {Promise} API response with item's department allocations
   */
  getDepartmentStockByItem: (itemId, params = {}) => 
    api.get(`/department-stock/item/${itemId}`, { params }),

  /**
   * Get departments with low stock levels
   * @param {Object} params - Query parameters (itemType, departmentType, etc.)
   * @returns {Promise} API response with low stock departments
   */
  getLowStockDepartments: (params = {}) => 
    api.get("/department-stock/low-stock", { params }),

  /**
   * Update minimum and maximum stock levels for a department-item allocation
   * @param {string} id - Department stock ID
   * @param {Object} data - Stock level data (minimumLevel, maximumLevel)
   * @returns {Promise} API response with updated department stock
   */
  updateStockLevels: (id, data) => 
    api.put(`/department-stock/${id}/levels`, data),

  /**
   * Get consumption rate for a department stock
   * @param {string} id - Department stock ID
   * @param {Object} params - Query parameters (period, startDate, endDate, etc.)
   * @returns {Promise} API response with consumption rate data
   */
  getConsumptionRate: (id, params = {}) => 
    api.get(`/department-stock/${id}/consumption`, { params }),
};


